/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* 25/09/2026: reescrito sem jQuery (mesmo comportamento da versão anterior) */

function poAll(sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); }
function poText(sel, ctx) { return poAll(sel, ctx).map(function (e) { return e.textContent; }).join(''); }

if (window.matchMedia("(max-width: 768px)").matches) {
  	window.onscroll = function() {
      var pageOffset = document.documentElement.scrollTop || document.body.scrollTop,
          btn = document.getElementById('scrollToTop');
      if (btn) btn.style.display = pageOffset > 1200 ? 'block' : 'none';
	}
}


function parcelamento2(){
  var preco = poText('.product-form__info-item .price.price--highlight, .price.precocheio').split('                  ')[0].replace('R$ ','').replace(',', '.').split(' ')[0].split('-')[0].trim()
  var compare = poText('.product-form__info-item .price--compare, .precode').replace('R$ ', '').replace(',','.')
  var compare = parseFloat(compare)
  var precompare = (compare - preco).toFixed(2).replace('.', ',')
  var porcent2 = ((compare - preco) * 100 / compare).toFixed()
  poAll('.porcentagemxporcentagem').forEach(function (e) { e.remove(); })
  poAll('span.price.precocheio.price--highlight').forEach(function (e) {
    e.insertAdjacentHTML('beforeend', '<span class="product-label product-label--on-sale discount__percentage porcentagemxporcentagem"> ↓  ' + porcent2 + '%</span>')
  })
}

poAll(".block-swatch__radio, .variant-swatch__radio").forEach(function (el) {
  el.addEventListener('change', function () {
    setTimeout(function () { if (typeof parcelamento === 'function') parcelamento(); }, 150);
  });
});

function increaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value++;
  document.getElementById('number').value = value;
}

function decreaseValue() {
  var value = parseInt(document.getElementById('number').value, 10);
  value = isNaN(value) ? 0 : value;
  value < 1 ? value = 1 : '';
  value--;
  document.getElementById('number').value = value;
}

poAll(".reviews").forEach(function (el) {
  el.addEventListener('click', function () {
    var alvo = document.getElementById('po-reviews');
    if (alvo) { window.scrollTo(0, alvo.getBoundingClientRect().top + window.pageYOffset); }
  });
});

if(location.href.split('=')[1] != undefined){
  var url = '.id-' + location.href.split('=')[1]
  try { poAll('.variantes ' + url).forEach(function (e) { e.classList.add('active'); }) } catch (e) {}
}else{
  poAll('.options:first-child').forEach(function (e) { e.classList.add('active'); })
}

poAll(".options").forEach(function (opt) {
    opt.addEventListener("click", function(){
      poAll('.options').forEach(function (e) { e.classList.remove('active'); })
      opt.classList.add('active')
      var desconto = document.querySelector('.options.active .selector-desconto')
      poAll('span.product-label.product-label--on-sale').forEach(function (e) { e.textContent = (desconto ? desconto.getAttribute('cup') : '') + ' off' })
      poAll('.precode').forEach(function (e) { e.remove(); })
      poAll('.price--compare').forEach(function (e) { e.remove(); })
      poAll('.price-list').forEach(function (e) { e.insertAdjacentHTML('beforeend', '<p class="precode">' + poText('.valortot span', opt) + '</p>') })
      var total = poText('.valortot b', opt)
      poAll('.price').forEach(function (e) { e.textContent = total })

      var cupom = desconto ? desconto.textContent : ''

      if(cupom != '')
      setTimeout(function(){
        parcelamento()
        parcelamento2()
       }, 100);
    });
});

poAll(".product-form").forEach(function (form) {
    form.addEventListener('click', function (event) {
      if (!event.target.closest || !event.target.closest('.botaocmprar')) return;
      event.stopImmediatePropagation();
      var ativo = document.querySelector('.options.active .iddavariante');
      var arraydeprodutos = [{
          id: parseInt(ativo && ativo.getAttribute('val')),
          quantity: parseInt(ativo && ativo.getAttribute('qtd'))
      }];
      console.log(arraydeprodutos)
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: arraydeprodutos })
      }).then(function (r) {
        if (!r.ok) return;
        setTimeout(function () { window.location.href = '/cart' }, 500);
      });
    });
})

poAll('.product-form__info-item--quantity').forEach(function (e) { e.remove(); })

document.addEventListener("DOMContentLoaded", function() {
    setTimeout(function() {
        var element = document.querySelector('.form_rastreio_1698873585.form-rastreio-email-order');
        if (element) {
            element.style.display = 'none';
        }
    }, 500);
});

document.addEventListener("DOMContentLoaded", function() {
    function hideSeparatorBlock() {
        var separatorBlock = document.querySelector('.form_separator_block_rastreio_1698873585');
        if (separatorBlock) {
            separatorBlock.style.setProperty('display', 'none', 'important');
        }
    }
    hideSeparatorBlock();
    var observer2 = new MutationObserver(function(mutations) {
        mutations.forEach(function() {
            hideSeparatorBlock();
        });
    });
    observer2.observe(document.body, { childList: true, subtree: true });
});
